import axios from "axios";

const API_BASE_URL = 'https://api.careoff.in/api/v1';
// const API_BASE_URL = "http://localhost:5003/api/v1";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    accept: "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// --- Auth ---
export const loginAdmin = async (data) => {
  const response = await apiClient.post("/admin/auth/login", data);
  return response.data;
};

export const getAdminProfile = async () => {
  const response = await apiClient.get("/admin/auth/profile");
  return response.data;
};

export const changeAdminPassword = async (data) => {
  const response = await apiClient.post("/admin/auth/change-password", data);
  return response.data;
};

export const forgotAdminPassword = async (data) => {
  const response = await apiClient.post("/admin/auth/forgot-password", data);
  return response.data;
};

export const verifyOtpForAdminPassword = async (data) => {
  const response = await apiClient.post("/admin/auth/verify-otp", data);
  return response.data;
};

export const resetAdminPassword = async (data) => {
  const response = await apiClient.post("/admin/auth/reset-password", data);
  return response.data;
};

export const getBanners = async () => {
  const response = await apiClient.get("/banners/admin");
  return response.data;
};

export const getFaqs = async (type = "vendor") => {
  const response = await apiClient.get(`/faqs?type=${type}`);
  return response.data;
};

export const getFaqById = async (id) => {
  const response = await apiClient.get(`/faqs/${id}`);
  return response.data;
};

export const getBannerById = async (id) => {
  const response = await apiClient.get(`/banners/${id}`);
  return response.data;
};

export const createFaq = async (data) => {
  const response = await apiClient.post("/faqs", data);
  return response.data;
};

export const updateFaq = async (id, data) => {
  const response = await apiClient.put(`/faqs/${id}`, data);
  return response.data;
};

export const deleteFaq = async (id) => {
  const response = await apiClient.delete(`/faqs/${id}`);
  return response.data;
};

export const createBanner = async (formData) => {
  const response = await apiClient.post("/banners", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const updateBanner = async (id, formData) => {
  const response = await apiClient.put(`/banners/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const deleteBanner = async (id) => {
  const response = await apiClient.delete(`/banners/${id}`);
  return response.data;
};

export const getContact = async () => {
  const response = await apiClient.get("/contact-us");
  return response.data;
};

export const updateContact = async (id, data) => {
  const response = await apiClient.put(`/contact-us/${id}`, data);
  return response.data;
};

export const createContact = async (data) => {
  const response = await apiClient.post("/contact-us", data);
  return response.data;
};

// --- CMS ---
export const getAllCms = async () => {
  const response = await apiClient.get("/cms-content");
  return response.data;
};

export const getCmsByType = async (type) => {
  const response = await apiClient.get(`/cms-content/${type}`);
  return response.data;
};

export const createCms = async (data) => {
  // data: { type, content }
  const response = await apiClient.post("/cms-content", data);
  return response.data;
};

export const updateCms = async (type, data) => {
  // Ensuring type is also in payload
  const response = await apiClient.put(`/cms-content/${type}`, {
    ...data,
    type,
  });
  return response.data;
};

export const deleteCms = async (type) => {
  const response = await apiClient.delete(`/cms-content/${type}`);
  return response.data;
};

// --- Categories ---
export const getCategories = async (page = 1, limit = 10, search = "") => {
  let url = `/categories/admin?page=${page}&limit=${limit}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  const response = await apiClient.get(url);
  return response.data;
};

export const createCategory = async (formData) => {
  const response = await apiClient.post("/categories", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const updateCategory = async (id, formData) => {
  const response = await apiClient.put(`/categories/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const deleteCategory = async (id) => {
  const response = await apiClient.delete(`/categories/${id}`);
  return response.data;
};

// --- Subcategories ---
export const getSubCategories = async (
  categoryId,
  page = 1,
  limit = 10,
  search = "",
) => {
  let url = `/sub-categories/admin/category/${categoryId}?page=${page}&limit=${limit}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  const response = await apiClient.get(url);
  return response.data;
};

export const createSubCategory = async (formData) => {
  const response = await apiClient.post("/sub-categories", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const updateSubCategory = async (id, formData) => {
  const response = await apiClient.put(`/sub-categories/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const deleteSubCategory = async (id) => {
  const response = await apiClient.delete(`/sub-categories/${id}`);
  return response.data;
};

// --- Products ---
export const getProductsBySubCategory = async (
  subCategoryId,
  page = 1,
  limit = 10,
  search = "",
) => {
  let url = `/products/admin/subCategory?subCategoryId=${subCategoryId}&page=${page}&limit=${limit}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  const response = await apiClient.get(url);
  return response.data;
};

export const createProduct = async (vendorId, formData) => {
  const response = await apiClient.post(
    `/products/create-product-admin/${vendorId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const updateProduct = async (id, formData) => {
  const response = await apiClient.put(
    `/products/update-product-admin/${id}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const getProductById = async (id) => {
  const response = await apiClient.get(`/products/${id}`);
  return response.data;
};

export const updateVariant = async (id, data) => {
  // data: { variantLabel, price, discountPrice, stockQuantity, ... }
  const response = await apiClient.put(`/products/${id}`, data);
  return response.data;
};

export const createVariant = async (data) => {
  // data: { productId, variantLabel, price, discountPrice, stockQuantity, ... }
  const response = await apiClient.post("/products", data);
  return response.data;
};

export const deleteProduct = async (id) => {
  const response = await apiClient.delete(`/products/${id}`);
  return response.data;
};

// Excel Bulk Upload for Products
export const downloadProductsTemplate = async () => {
  const response = await apiClient.get("/products/admin/download-template", {
    responseType: "blob",
  });
  return response;
};

export const uploadProductsExcel = async (formData) => {
  const response = await apiClient.post("/products/admin/upload-excel", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// --- Users ---
export const getAllUsers = async (page = 1, limit = 10, search = "") => {
  let url = `/users/admin/get-all-user?page=${page}&limit=${limit}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  const response = await apiClient.get(url);
  return response.data;
};

export const getUserById = async (id) => {
  const response = await apiClient.get(`/users/admin/get-user/${id}`);
  return response.data;
};

export const getUserAddresses = async (id, page = 1, limit = 20) => {
  const response = await apiClient.get(
    `/addresses/admin/${id}/address?page=${page}&limit=${limit}&includeDeleted=false`,
  );
  return response.data;
};

export const downloadUsersExcel = async () => {
  const response = await apiClient.get("/users/download-all", {
    responseType: "blob",
  });
  return response.data;
};

// --- Vendors ---
export const getAllVendors = async (
  page = 1,
  limit = 10,
  search = "",
  isActive = "",
) => {
  let url = `/vendor/all?page=${page}&limit=${limit}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  if (isActive !== "") {
    url += `&isActive=${isActive}`;
  }
  const response = await apiClient.get(url);
  return response.data;
};

export const getAllVendorsWithoutPagination = async () => {
  const response = await apiClient.get("/vendor/all-vendors");
  return response.data;
};

export const createVendor = async (formData) => {
  const response = await apiClient.post("/vendor/register", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const getVendorById = async (id, categoryType = "") => {
  let url = `/vendor/admin/${id}`;
  if (categoryType) {
    url += `?categoryType=${encodeURIComponent(categoryType)}`;
  }
  const response = await apiClient.get(url);
  return response.data;
};

export const updateVendor = async (id, formData) => {
  const response = await apiClient.put(`/vendor/admin/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const deleteVendor = async (id) => {
  const response = await apiClient.delete(`/vendor/admin/${id}`);
  return response.data;
};

// Food Vendor APIs
export const getAllFoodVendors = async (
  page = 1,
  limit = 10,
  search = "",
  isActive = "",
) => {
  let url = `/food-vendor/all?page=${page}&limit=${limit}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  if (isActive !== "") url += `&isActive=${isActive}`;
  const response = await apiClient.get(url);
  return response.data;
};

export const getFoodVendorById = async (id) => {
  const response = await apiClient.get(`/food-vendor/admin/${id}`);
  return response.data;
};

// Bank Details APIs
export const getVendorBankDetails = async (vendorId) => {
  const response = await apiClient.get(
    `/bank-details/admin/get-bank-details/${vendorId}`,
  );
  return response.data;
};

export const upsertVendorBankDetails = async (vendorId, data) => {
  const response = await apiClient.post(
    `/bank-details/admin/create-bank-details/${vendorId}`,
    data,
  );
  return response.data;
};

export const createFoodVendor = async (formData) => {
  const response = await apiClient.post(`/food-vendor/register`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const updateFoodVendor = async (id, formData) => {
  const response = await apiClient.put(`/food-vendor/admin/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const deleteFoodVendor = async (id) => {
  const response = await apiClient.delete(`/food-vendor/admin/${id}`);
  return response.data;
};

// --- Service Locations ---
export const getAllServiceLocations = async (
  page = 1,
  limit = 10,
  search = "",
) => {
  let url = `/service-locations?page=${page}&limit=${limit}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  const response = await apiClient.get(url);
  return response.data;
};

export const getActiveServiceLocations = async () => {
  const response = await apiClient.get("/service-locations/admin/active");
  return response.data;
};

export const getServiceLocationById = async (id) => {
  const response = await apiClient.get(`/service-locations/${id}`);
  return response.data;
};

export const createServiceLocation = async (data) => {
  const response = await apiClient.post("/service-locations", data);
  return response.data;
};

export const updateServiceLocation = async (id, data) => {
  const response = await apiClient.put(`/service-locations/${id}`, data);
  return response.data;
};

export const deleteServiceLocation = async (id) => {
  const response = await apiClient.delete(`/service-locations/${id}`);
  return response.data;
};

// --- Partners ---
export const getAllPartners = async (page = 1, limit = 10, search = "") => {
  let url = `/partner/admin/get-all-partner?page=${page}&limit=${limit}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  const response = await apiClient.get(url);
  return response.data;
};

export const getGroceryPartners = async () => {
  const response = await apiClient.get("/partner/get-grocery-partners");
  return response.data;
};




export const getPartnerById = async (id) => {
  const response = await apiClient.get(`/partner/admin/${id}`);
  return response.data;
};

export const createPartner = async (data) => {
  const response = await apiClient.post("/partner/register", data);
  return response.data;
};

export const updatePartner = async (id, data) => {
  const response = await apiClient.put(`/partner/admin/${id}`, data);
  return response.data;
};

export const deletePartner = async (id) => {
  const response = await apiClient.delete(`/partner/admin/${id}`);
  return response.data;
};

export const updatePartnerGoals = async (goals) => {
  const response = await apiClient.put(`/partner/goals`, {
    goals: Number(goals),
  });
  return response.data;
};

export const getAllFoodCategories = async (
  page = 1,
  limit = 10,
  search = "",
) => {
  let url = `/food/menu-categories/admin?page=${page}&limit=${limit}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  const response = await apiClient.get(url);
  return response.data;
};

export const createFoodCategory = async (formData) => {
  const response = await apiClient.post(`/food/menu-categories`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const updateFoodCategory = async (id, formData) => {
  const response = await apiClient.put(
    `/food/menu-categories/${id}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const deleteFoodCategory = async (id) => {
  const response = await apiClient.delete(`/food/menu-categories/${id}`);
  return response.data;
};

export const getVendorMenuItems = async (vendorId) => {
  const response = await apiClient.get(`/food/menu-items/admin/${vendorId}`);
  return response.data;
};

export const downloadAllPartnersExcel = async () => {
  const response = await apiClient.get("/partner/download-all", {
    responseType: "blob",
  })
  return response.data;
}


// --- Time Slots ---
export const getAllTimeSlots = async () => {
  const response = await apiClient.get("/time-slots");
  return response.data;
};

export const createTimeSlot = async (data) => {
  const response = await apiClient.post("/time-slots", data);
  return response.data;
};

export const updateTimeSlot = async (id, data) => {
  const response = await apiClient.put(`/time-slots/${id}`, data);
  return response.data;
};

export const deleteTimeSlot = async (id) => {
  const response = await apiClient.delete(`/time-slots/${id}`);
  return response.data;
};

export const getPartnerBookings = async (
  partnerId,
  page = 1,
  limit = 10,
  search = "",
) => {
  const response = await apiClient.get(
    `/partner/bookings/admin/bookings/${partnerId}?page=${page}&limit=${limit}&search=${search}`,
  );
  return response.data;
};

export const downloadPartnersExcel = async () => {
  const response = await apiClient.get("/partner/download-partners", {
    responseType: "blob",
  });
  return response.data;
};

// --- Bookings ---
export const getAllFoodBookings = async (
  page = 1,
  limit = 10,
  search = "",
  status = "",
  paymentStatus = "",
  locationId = "",
) => {
  let url = `/food/booking/admin?page=${page}&limit=${limit}`;
  if (search) url += `&search=${search}`;
  if (status && status !== "all") url += `&status=${status}`;
  if (paymentStatus && paymentStatus !== "all")
    url += `&paymentStatus=${paymentStatus}`;
  if (locationId && locationId !== "all") url += `&locationId=${locationId}`;
  const response = await apiClient.get(url);
  return response.data;
};

export const getFoodBookingById = async (id) => {
  const response = await apiClient.get(`/food/booking/admin/${id}`);
  return response.data;
};

// --- Grocery Bookings ---
export const getAllGroceryBookings = async (
  page = 1,
  limit = 10,
  search = "",
  status = "",
  paymentStatus = "",
  locationId = "",
) => {
  let url = `/booking/admin?page=${page}&limit=${limit}`;
  if (search) url += `&search=${search}`;
  if (status && status !== "all") url += `&status=${status}`;
  if (paymentStatus && paymentStatus !== "all")
    url += `&paymentStatus=${paymentStatus}`;
  if (locationId && locationId !== "all") url += `&locationId=${locationId}`;
  const response = await apiClient.get(url);
  return response.data;
};

export const updateGroceryBookingStatus = async (id, data) => {
  const response = await apiClient.put(`/booking/admin/${id}`, data);
  return response.data;
};

export const assignPartnerToBooking = async (id, data) => {
  // data: { partnerId: 'uuid' }
  const response = await apiClient.put(`/booking/assign-partner/${id}`, data);
  return response.data;
};

export const getGroceryBookingById = async (id) => {
  const response = await apiClient.get(`/booking/admin/${id}`);
  return response.data;
};

// --- Product Features ---
export const getAllFeatures = async () => {
  const response = await apiClient.get("/product-features");
  return response.data;
};

export const createFeature = async (formData) => {
  const response = await apiClient.post("/product-features", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const updateFeature = async (id, formData) => {
  const response = await apiClient.put(`/product-features/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const deleteFeature = async (id) => {
  const response = await apiClient.delete(`/product-features/${id}`);
  return response.data;
};

// --- Service Configurations ---
export const getAllServiceConfigs = async () => {
  const response = await apiClient.get("/service-config");
  return response.data;
};

export const createServiceConfig = async (data) => {
  const response = await apiClient.post("/service-config", data);
  return response.data;
};

export const updateServiceConfig = async (id, data) => {
  const response = await apiClient.put(`/service-config/${id}`, data);
  return response.data;
};

export const deleteServiceConfig = async (id) => {
  const response = await apiClient.delete(`/service-config/${id}`);
  return response.data;
};

// --- Coupons ---
export const getAllCoupons = async (
  page = 1,
  limit = 10,
  type = "",
  isActive = "",
  search = "",
) => {
  const params = { page, limit };
  if (type) params.type = type;
  if (isActive !== "") params.isActive = isActive;
  if (search) params.search = search;
  const response = await apiClient.get("/coupons", { params });
  return response.data;
};

export const createCoupon = async (data) => {
  const response = await apiClient.post("/coupons", data);
  return response.data;
};

export const updateCoupon = async (id, data) => {
  const response = await apiClient.put(`/coupons/${id}`, data);
  return response.data;
};

export const getCouponById = async (id) => {
  const response = await apiClient.get(`/coupons/${id}`);
  return response.data;
};

export const deleteCoupon = async (id) => {
  const response = await apiClient.delete(`/coupons/${id}`);
  return response.data;
};

// --- Payment Transactions ---
export const getAllPaymentTransactions = async (
  page = 1,
  limit = 10,
  bookingId = "",
  status = "",
  gateway = "",
) => {
  let url = `/payment-transactions?page=${page}&limit=${limit}`;
  if (bookingId) url += `&bookingId=${encodeURIComponent(bookingId)}`;
  if (status && status !== "--") url += `&status=${encodeURIComponent(status)}`;
  if (gateway) url += `&gateway=${encodeURIComponent(gateway)}`;
  const response = await apiClient.get(url);
  return response.data;
};

export const getPaymentTransactionById = async (id) => {
  const response = await apiClient.get(
    `/payment-transactions/get-transaction/${id}`,
  );
  return response.data;
};

// --- Vendor Wallet / Payouts ---
export const getVendorPayoutList = async (
  page = 1,
  limit = 10,
  minAmount = "",
) => {
  let url = `/vendor-wallet/admin/payout-list?page=${page}&limit=${limit}`;
  if (minAmount !== "" && minAmount !== null) {
    url += `&minAmount=${minAmount}`;
  }
  const response = await apiClient.get(url);
  return response.data;
};

export const exportPayoutExcel = async () => {
  const response = await apiClient.get(
    "/vendor-wallet/admin/export-payout-excel",
    {
      responseType: "blob",
    },
  );
  return response;
};

export const importPayoutExcel = async (formData) => {
  const response = await apiClient.post(
    "/vendor-wallet/admin/import-payout-excel",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

// Analytics / Dashboard Services
export const getDashboardStats = async (fromDate, toDate, locationId = "") => {
  let url = "/admin/dashboard/stats";
  const params = new URLSearchParams();
  if (fromDate) params.append("fromDate", fromDate);
  if (toDate) params.append("toDate", toDate);
  if (locationId && locationId !== "all")
    params.append("locationId", locationId);
  if (params.toString()) url += `?${params.toString()}`;

  const response = await apiClient.get(url);
  return response.data;
};

// --- Service Sub Categories ---
export const getServiceSubCategories = async (
  page = 1,
  limit = 10,
  categoryId = "",
  search = "",
) => {
  let url = `/services/service-sub-categories?page=${page}&limit=${limit}`;
  if (categoryId) url += `&categoryId=${categoryId}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;

  const response = await apiClient.get(url);
  return response.data;
};

export const createServiceSubCategory = async (formData) => {
  const response = await apiClient.post(
    "/services/service-sub-categories",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const updateServiceSubCategory = async (id, formData) => {
  const response = await apiClient.put(
    `/services/service-sub-categories/${id}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const deleteServiceSubCategory = async (id) => {
  const response = await apiClient.delete(
    `/services/service-sub-categories/${id}`,
  );
  return response.data;
};

export const getServiceSubCategoryById = async (id) => {
  const response = await apiClient.get(
    `/services/service-sub-categories/${id}`,
  );
  return response.data;
};

// --- Service Options ---
export const getServiceOptions = async (
  subServiceId,
  page = 1,
  limit = 10,
  search = "",
) => {
  let url = `/services/service-options/admin/sub-category/${subServiceId}?page=${page}&limit=${limit}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;

  const response = await apiClient.get(url);
  return response.data;
};

export const deleteServiceOption = async (id) => {
  const response = await apiClient.delete(`/services/service-options/${id}`);
  return response.data;
};

export const createServiceOption = async (formData) => {
  const response = await apiClient.post("/services/service-options", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const updateServiceOption = async (id, formData) => {
  const response = await apiClient.put(
    `/services/service-options/${id}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const getServiceOptionById = async (id) => {
  const response = await apiClient.get(`/services/service-options/${id}`);
  return response.data;
};

// --- Service Bookings ---
export const getAllServiceBookings = async (
  page = 1,
  limit = 10,
  status = "",
  paymentStatus = "",
  search = "",
  locationId = "",
) => {
  let url = `/services/bookings/get-all?page=${page}&limit=${limit}`;
  if (status) url += `&status=${encodeURIComponent(status)}`;
  if (paymentStatus)
    url += `&paymentStatus=${encodeURIComponent(paymentStatus)}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  if (locationId && locationId !== "all")
    url += `&locationId=${encodeURIComponent(locationId)}`;

  const response = await apiClient.get(url);
  return response.data;
};

export const getServiceBookingById = async (id) => {
  const response = await apiClient.get(`/services/bookings/admin/get-by-id/${id}`);
  return response.data;
};

// --- Service Categories ---
export const getServiceCategories = async (page = 1, limit = 10) => {
  const response = await apiClient.get(
    `/services/service-sub-categories/service-category?page=${page}&limit=${limit}`,
  );
  return response.data;
};

// --- Push Notifications ---
export const sendPushNotification = async (notificationData) => {
  const response = await apiClient.post(
    "/notifications/notify-all-users",
    notificationData,
  );
  return response.data;
};

// --- Vendor Inventory ---
export const getVendorInventory = async (
  vendorId,
  page = 1,
  limit = 10,
  search = "",
) => {
  let url = `/products/admin/vendor/${vendorId}?page=${page}&limit=${limit}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;

  try {
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("API getVendorInventory error:", error);
  }
};

// --- Partners ---
export const getServicePartners = async () => {
  const response = await apiClient.get("/partner/get-service-partners");
  return response.data;
};

export const assignServicePartner = async (bookingId, partnerId) => {
  const response = await apiClient.post(`/partner/bookings/assign/${bookingId}`, { partnerId });
  return response.data;
};

export default apiClient;

